import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Dashboard3Drawers from '../dashboard-3-drawers/Dashboard3Drawers';
import { drawerRoutesPropTypes } from '../dashboard-3-drawers/d3d-prop-types';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
}));

const CRUDDetailPage = (props) => {
  const {
    routes,
    drawerRoutes,
    AuthenticationRepository,
    applicationName,
    logo,
    icons,
    ComponentContent,
  } = props;
  const classes = useStyles();

  const { ComponentContent: Comp, ...contentProps } = props;

  return (
    <Dashboard3Drawers
      AuthenticationRepository={AuthenticationRepository}
      routes={drawerRoutes}
      applicationName={applicationName}
      logo={logo}
      icons={icons}
      titleId={routes.detail.titleId}
      useBackButton
      breadcrumbs={[
        {
          id: 'index',
          href: routes.index.path,
          titleId: routes.index.titleId,
        },
        {
          id: 'detail',
          titleId: routes.detail.titleId,
        },
      ]}
    >
      <Paper className={classes.paper}>
        <ComponentContent
          {...contentProps}
        />
      </Paper>
    </Dashboard3Drawers>
  );
};

CRUDDetailPage.propTypes = {
  routes: PropTypes.shape({
    index: PropTypes.shape({
      path: PropTypes.string,
      titleId: PropTypes.string,
    }),
    detail: PropTypes.shape({
      titleId: PropTypes.string,
    }),
  }).isRequired,
  drawerRoutes: drawerRoutesPropTypes.isRequired,
  AuthenticationRepository: PropTypes.func.isRequired,
  applicationName: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  icons: PropTypes.objectOf(PropTypes.object).isRequired,
  ComponentContent: PropTypes.func.isRequired,
};

CRUDDetailPage.defaultProps = {

};

export default CRUDDetailPage;
